/* eslint-disable @next/next/no-img-element */

// @material-tailwind/react components
import { Typography } from "@material-tailwind/react";

// page components
import CodePreview from "components/cards/code-preview";

export default function SectionShadow() {
  return (
    <section className="py-12">
      <div className="flex flex-wrap items-center">
        <div className="relative w-full px-4 md:w-5/12">
          <Typography
            variant="h2"
            className="mb-2 font-black tracking-normal text-[#1A237E]"
          >
            Realistic <br />
            <Typography
              as="span"
              variant="h2"
              color="blue"
              className="inline-block font-black tracking-normal"
              textGradient
            >
              Shadows
            </Typography>{" "}
            included.
          </Typography>
          <Typography className="mb-5 text-lg text-[#1A237E]/60 md:pr-10">
            Known for its simplicity and readability, Python is popular in web
            development Django, Flask, data analysis, scientific computing,
            machine learning, and automation.
          </Typography>
        </div>
        <div className="relative w-3/4 px-4 pt-6 md:w-5/12 md:pt-0">
          <CodePreview
            code={`
age = int(input("Enter your age: "))

if age >= 18:
  print("You are eligible to vote.")
else:
  print("You are not eligible to vote yet.")
            `}
          />
          <img
            className="absolute -bottom-16 w-full md:bottom-auto md:top-24 md:-right-5 lg:top-10 lg:-right-40"
            src="/img/blue.png"
            alt="tailwind_blob_blue"
          />
        </div>
      </div>
    </section>
  );
}
